import * as MultiGridStyles from '~/components/MultiGrid/styles';
import { IBaseFieldData } from '~/components/MultiGrid/types';

interface IHeaderContentProps {
  fieldData: IBaseFieldData;
}

const HeaderContent = ({ fieldData }: IHeaderContentProps) => {
  return (
    <MultiGridStyles.HeaderWrapper className="spread full-dimension" isActive={false}>
      {fieldData.label}
    </MultiGridStyles.HeaderWrapper>
  );
};

export default HeaderContent;
